import client from '@/api/base';
import clientCas from '@/api/baseOfCas';
import clientCoach from '@/api/baseOfCoach';

// Children
import admin from './admin/admin';
import coach from './coach/coach';
import notification from './notification/notification';
import registration from './registration/registration';
import leader from './leader/leader';
import demographics from './demographics/demographics';

export default {

  async accountSignUp(data) {
    const response = await client.post('account/signup/', data);
    return response;
  },

  async login(d) {
    const data = d;
    if (data.email) data.email = data.email.toLowerCase();
    const response = await client.post('account/login/', data);
    return response;
  },

  async logout() {
    const response = await clientCas.post('logout/');
    return response;
  },

  // async resetPassword(data) {
  //   const response = await client.post('account/password/reset/', data);
  //   return response;
  // },

  // async resetPasswordConfirm(data) {
  //   const response = await client.post('account/password/reset/confirm/', data);
  //   return response;
  // },

  async resetLocalUserPassword(data) {
    const response = await client.post('local-user/password/reset/', data);
    return response;
  },

  async validateLocalUserToken(uid64, token) {
    const response = await client.get(`local-user/password/reset/${uid64}/${token}/`);
    return response;
  },

  async submitResetLocalUserPassword(uid64, token, data) {
    const response = await client.post(`local-user/password/reset/${uid64}/${token}/`, data);
    return response;
  },

  async accountUnlock(uid64, token) {
    const response = await client.patch(`account/unlock/${uid64}/${token}/`);
    return response;
  },

  async unknownAllowIP(uid64, token, data) {
    const response = await client.patch(`account/unknown-ip/${uid64}/${token}/`, data);
    return response;
  },

  async unknownResetPassword(uid64, token, data) {
    const response = await client.patch(`account/unknown-ip/${uid64}/${token}/`, data);
    return response;
  },

  async getCurrentUser() {
    const response = await client.get('account/current-user/');
    return response;
  },

  async getTimezoneList() {
    const response = await clientCas.get('time-zones/');
    return response;
  },

  async getCountriesList() {
    const response = await clientCoach.get('common/countries/');
    return response;
  },

  async getRegionList(id) {
    const response = await clientCoach.get(`common/country/${id}/regions/`);
    return response;
  },

  async getCityList(id) {
    const response = await clientCoach.get(`common/region/${id}/cities/`);
    return response;
  },

  async getVatCountriesList() {
    const response = await client.get('account/vat-countries/');
    return response;
  },

  async getLanguagesList() {
    const response = await client.get('account/languages/');
    return response;
  },

  async updateUserPassword(data) {
    const response = await client.post('account/password/change/', data);
    return response;
  },

  async getCoachLanguages() {
    const response = await client.get('coaching/languages/');
    return response;
  },

  async connectToGoogle(data) {
    const response = await client.post('account/google/oauth/conn/', data);
    return response;
  },

  async getPaymentStatus() {
    const response = await client.get('account/payment-status/');
    return response;
  },

  // Children
  ...admin,
  ...coach,
  ...notification,
  ...registration,
  ...leader,
  ...demographics,
};
